export const extractShadowColor = (boxShadow: string | null): string | undefined => {
  const COLOR_REGEX = /#[0-9a-fA-F]{3,6}|rgba?\([^)]+\)|hsla?\([^)]+\)/;
  const match = boxShadow?.match(COLOR_REGEX);
  if (match) {
    return match[0];
  } else {
    return;
  }
};
